import React from 'react'
import { Tab } from '@softura/fluentuipackage';
import './quotes.scss';
import MyQuotes from '../MyQuotes';
import SharedQuotes from '../SharedQuotes';
import Archive from '../Archive';
import Archiveicon from '../../../assets/images/Archiveicon.svg'
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import Alerts from '../../Alerts';
import { ModalPopup } from '../../CommonComponent';
import Share from '../MyQuotes/Share';
import Loader from '../../Loader';

import { IProps } from './quotesinterface';
import SaveCartPopUp from '../SaveCartPopUp';

const Quotes = (props: IProps) => {

    const { t } = useTranslation();

    const contentProps = {
                addToCart : props?.addToCart, 
                share :  props?.share,
                archiveQuote :  props?.archiveQuote, 
                onSelectionChange :props?.onSelectionChange, 
                data : props?.gridData ,
                isLoading : props?.isLoading,
                selectAll : props?.selectAll, 
                selectedItem: props?.selectedItem, 
                setSelectedItem: props?.setSelectedItem, 
                gridRef: props?.gridRef,
                mount: props?.mount ,
                setMount:props?.setMount,
                showsharedDetails: props?.showsharedDetails, 
                onCommentChange: props?.onCommentChange ,
                quoteDetailList: props?.quoteDetailList ,
                decrementCount: props?.decrementCount ,
                incrementCount: props?.incrementCount ,
                updateCheckedItems: props?.updateCheckedItems ,
                onQuoteClick: props?.onQuoteClick ,
                selectedDetailItem: props?.selectedDetailItem, 
                downloadAttachment: props?.downloadAttachment ,
                onQuantityChange:  props?.onQuantityChange 
    }
    const tabItems = [
        {
            headerText: t(RESOURCE.MyK_Label_ShoppingCart_MyQuotes),
            content: <MyQuotes
                {...contentProps}
            />
        },
        {
            headerText: t(RESOURCE.MyK_Label_ShoppingCart_SharedQuotes),
            content: <SharedQuotes
                {...contentProps}
            />
        },
        {
            headerText: t(RESOURCE.MyK_Label_ShoppingCart_Archive),
            content: <Archive
                {...contentProps}
                tab={props.tab}
            />
        }
    ];

    const isDisabled = props?.showsharedDetails ? !props?.selectedDetailItem?.quoteList?.length : !props?.gridData?.length;
    const isLoading = (props?.shareQuoteRes?.loading || props?.deleteOrArchiveQuoteRes?.loading || props?.saveQuoteRes?.loading || props?.addToCartQuoteRes?.loading || props?.quoteDetailList?.loading);

    return (
        <div className='quotesgrid_wrapper'>
            {isLoading && <Loader />}
            <div className='quotesgrid_wrapper-hd'>
                {props?.showsharedDetails && <span className='quoteBack'
                    onClick={() => props?.quoteShareClickBack()} onKeyDown={() => { }}>
                    <em className="fa fa-arrow-left mr-2" aria-hidden="true"></em>{t(RESOURCE.MyK_Label_ShoppingCart_Back_to_Quote)}</span>}
                <div className="col-12 mb-2 mt-2">
                    {props?.showAlert && (
                        <Alerts
                            messageAlert={props?.errorSuccessMessage}
                            alertType={props?.alertType}
                            time={3000} onClose={() => props?.handleAlertClose()}
                        />
                    )}
                    {props?.redirectErrorMsg && <Alerts
                        messageAlert={props?.redirectErrorMsg}
                        alertType="error"
                        time={3000}
                        onClose={() => props?.handleRedirectAlertClose()}
                        />}
                </div>
                {props?.showPopup && (
                    <div className='shareview'>
                    <ModalPopup
                        ModalPopupTitle={t(RESOURCE.MyK_Label_Share)}
                        ModalPopupType="smaller"
                        closeModalPopup={() => props?.openSharePopup()}
                    >
                        <Share
                            openSharePopup={() => props?.openSharePopup()}
                            shareQuoteService={props?.shareQuoteService}
                            selectedItem={props?.selectedItem}
                            showShareAlert={props.showShareAlert}
                            setShowShareAlert={props.setShowShareAlert}
                            errorShareMsg={props.errorShareMsg}
                            setErrorShareMsg={props.setErrorShareMsg}
                        />
                    </ModalPopup>
                    </div>
                )}
                <div className='right_buttons mb-2'>
                    <button
                        className={`secondarybutton mr-1 mb-sm-0 mb-2 ${isDisabled ? 'disabled' : ''}`}
                        onClick={() => props?.deleteOrArchiveQuote("Delete")}
                        title={t(RESOURCE.MyK_Label_Delete)}>
                        <span className='fa fa-trash mr-1 deleteQuote'></span>{t(RESOURCE.MyK_Label_Delete)}</button>
                    {props.tab != props.archivetab && <button
                        className={`primarybutton mr-1 mb-sm-0 mb-2 ${isDisabled ? 'disabled' : ''}`}
                        onClick={() => props?.deleteOrArchiveQuote("Archive")}
                        title={t(RESOURCE.MyK_Label_ShoppingCart_Archive)}>
                        <img src={Archiveicon} className='archiveicon mr-1'></img>
                        {t(RESOURCE.MyK_Label_ShoppingCart_Archive)}</button>
                    }
                    <button
                        className={`primarybutton mr-1 mb-sm-0 mb-2 ${isDisabled ? 'disabled' : ''}`}
                        onClick={() => props?.saveQuote()}>
                        <span className='fa fa-bookmark-o mr-1'
                            title={t(RESOURCE.MyK_Label_ShoppingCart_SaveQuote)}></span>
                        {t(RESOURCE.MyK_Label_ShoppingCart_SaveQuote)}</button>
                    <button
                        className={`primarybutton mr-1 mb-sm-0 mb-2 ${isDisabled ? 'disabled' : ''}`}
                        onClick={() => props?.addToCartQuote()}>
                        <span className='fa fa-shopping-cart mr-1'
                            title={t(RESOURCE.MyK_Label_AddToCart)} ></span>
                        {t(RESOURCE.MyK_Label_AddToCart)}</button>
                    <button
                        className={`primarybutton mb-sm-0 mb-2 ${isDisabled ? 'disabled' : ''}`}
                        onClick={() => props?.excelExport()}>
                        <span className='fa fa-file-excel-o mr-1'
                            title={t(RESOURCE.MyK_Label_ExportToExcel)}></span>
                        {t(RESOURCE.MyK_Label_ExportToExcel)}</button>
                </div>
            </div>
            <div className='quotesgrid'>
                <Tab tabItems={tabItems} selectedKey={String(props.selectedKey)} className="mainTab" onLinkClick={props?.handleLinkClick} />
            </div>
            <div className='footerbtns mt-2'>
                <button className={`secondarybutton mr-1 ${isDisabled ? 'disabled' : ''}`} onClick={() => props?.shareQuote()}><span className='fa fa-share mr-1'></span>{t(RESOURCE.MyK_Label_Share)}</button>
                <button className={`primarybutton ${isDisabled ? 'disabled' : ''}`} onClick={() => props?.addToCartQuote()}><span className='fa fa-shopping-cart mr-1'></span>{t(RESOURCE.MyK_Label_AddToCart)}</button>
            </div>
            {props?.isShowSavePopup && <SaveCartPopUp
                SaveOnClick={(saveInfo: any) => props?.saveQuoteService(saveInfo)}
                closePopup={() => { props?.handleIsShowSavePopup(false) }}
                isQuote={true}
            />}
        </div>

    )

}
export default Quotes;